import { useEffect, useState } from 'react'
import Spacing from '../../../componenets/UI/Spacing'
import { Helmet } from 'react-helmet'
import { useTranslation } from 'react-i18next'
import useFeedbackActions from '../hooks/useFeedbackActions'
import { useFeedbacksContext } from '../context/feedbacks/FeedbacksProvider'
import { Navigate, useNavigate, useParams } from 'react-router'
import ResponsesSection from '../components/ResponsesSection'
import { toastError, toastSuccess } from '../../../config/global'
import LoaderQuestion from '../components/LoaderQuestion'

export default function FeedbacksPage() {
  const { lng } = useParams()
  const { t } = useTranslation()
  const navigate = useNavigate()
  const { feedbacksState, feedbacksDispatch } = useFeedbacksContext()
  const { getQuestions, sendAnswer, inProgress } = useFeedbackActions()

  const [answer, setAnswer] = useState({
    feedback: '',
    responses: [],
  })

  useEffect(() => {
    getQuestions()
  }, [])

  async function handleSubmit() {
    try {
      const message = await sendAnswer(answer)
      if (message) {
        toastSuccess(message)
        localStorage.setItem('FEEDBACK_SUBMITTED', 'true')
        navigate(`/${lng}/home`)
      }
    } catch (error) {
      if (!error.response && !error.request) {
        toastError('لم يتم الاتصال بالخادم. يرجى التحقق من الاتصال بالإنترنت.')
      } else if (error.response) {
        toastError(error.response.data.error)
      } else if (error.request) {
        toastError('لم يتم استلام استجابة من الخادم. حاول مرة أخرى لاحقًا.')
      } else {
        toastError('حدث خطأ غير متوقع. حاول مرة أخرى لاحقًا.')
      }
    }
  }

  if (localStorage.getItem('FEEDBACK_SUBMITTED') === 'true') {
    return (
      <Navigate
        to={`/${lng}/home`}
        replace={true}
      />
    )
  }

  return (
    <div>
      <Helmet>
        <title>{`APFM | ${t('FEEDBACKS')}`}</title>
      </Helmet>
      <Spacing />
      <div className={`app-container px-8 lg:px-0`}>
        <div
          data-aos={`fade-up`}
          data-aos-delay={100}
          className="mb-4 w-full overflow-hidden lg:h-[321px]"
        >
          <img
            src={t('FEEDBACKS_IMG')}
            alt="value chain banner"
            className="h-full w-full object-cover object-center"
          />
        </div>
        <p
          className="mb-2"
          data-aos={`fade-up`}
          data-aos-delay={100}
        >
          {t('FEEDBACKS_FIRST_MESSAGE')}
        </p>
        {feedbacksState.isLoading ? (
          <LoaderQuestion />
        ) : (
          <>
            <div className="flex flex-col gap-6">
              {feedbacksState.questions?.map((question, index) => (
                <ResponsesSection
                  key={index}
                  setAnswer={setAnswer}
                  question={question}
                />
              ))}
            </div>
            <p
              className="py-4"
              data-aos={`fade-up`}
              data-aos-delay={100}
            >
              {t('thank_you_message')}
            </p>
            <div
              data-aos={`fade-up`}
              data-aos-delay={100}
            >
              <button
                type="button"
                onClick={handleSubmit}
                disabled={inProgress}
                className="w-full bg-primary-600 py-3 text-white transition hover:bg-primary-700 disabled:bg-muted-600"
              >
                {inProgress ? t('inprogress') : t('send')}
              </button>
            </div>
          </>
        )}
      </div>
    </div>
  )
}
